import { ChangeEvent, LookupModelSearchEvent } from "@mcleod/components";
import { AutogenLayoutUnbilledOrdersReport } from "./autogen/AutogenLayoutUnbilledOrdersReport";

export class UnbilledOrdersReport extends AutogenLayoutUnbilledOrdersReport {
    override onLoad(): void {
        this.textboxReportBy.selectedItem = this.textboxReportBy.items[0];
        this.textboxGroupBy.selectedItem = this.textboxGroupBy.items[0];
        this.textboxTransferStatus.selectedItem = this.textboxTransferStatus.items[1];
    }

    textboxCustomersBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_active = "Y"
        event.filter.type_of = "C"
    }
    textboxDispatchersBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.web_user_type = "U"
    }

    /** This is an event handler for the onChange event of textboxGroupBy. */
    textboxGroupByOnChange(event: ChangeEvent) {
        //Handle sort by changes
        if(this.textboxGroupBy.selectedItem?.value == "Order status") {
            this.switchSortBy.enabled = false
            this.switchSortBy.checked = true
            this.switchSortBy.leftCaption = "N/A"
            this.switchSortBy.rightCaption = "Order Status Code"
        }
        else if (this.textboxGroupBy.selectedItem) {
            this.switchSortBy.enabled = true
            this.switchSortBy.leftCaption = this.textboxGroupBy.selectedItem?.displayValue + " Name"
            this.switchSortBy.rightCaption = this.textboxGroupBy.selectedItem?.displayValue + " Code"
        }
        else {
            this.switchSortBy.enabled = true
            this.switchSortBy.leftCaption = "N/A"
            this.switchSortBy.rightCaption = "Order Status Code"
        }
        this.switchSortBy.leftValue = this.textboxGroupBy.selectedItem?.value + " name"
        this.switchSortBy.rightValue = this.textboxGroupBy.selectedItem?.value + " code"

        //Handle exclude customer info changes
        if(this.textboxGroupBy.selectedItem?.value == "Customer") {
            this.switchCustomerInfo.checked = true
            this.switchCustomerInfo.enabled = false
        }
        else {
            this.switchCustomerInfo.enabled = true
        }
    }
}
